import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ChatSupportChannel, IChatConfiguration } from '@nx-fe/services';
import { DeviceChatDialogState, ErrorViewType, SabhaState } from './reducers';

export const getSabhaState = createFeatureSelector<SabhaState>('sabha');

export const getSabhaUserId = createSelector(
  getSabhaState,
  (state: SabhaState) => state.sabhaUserId
);

export const isSabhaAllowed = createSelector(
  getSabhaState,
  (state: SabhaState) => state.isSabhaAllowed
);

export const getShowOnboarding = createSelector(
  getSabhaState,
  (state: SabhaState) => state.showOnboarding
);

export const getSabhaUserPreference = createSelector(
  getSabhaState,
  (state: SabhaState) => state.sabhaUserPreference
);

export const getCurrentView = createSelector(
  getSabhaState,
  (state: SabhaState) => state.deviceChatDialog.currentView
);

export const getRingRoomIds = createSelector(
  getSabhaState,
  (state: SabhaState) => state.rings
);

export const getInactiveRoomIds = createSelector(
  getSabhaState,
  (state: SabhaState) => state.inactiveRoomIds
);

export const getErrorViewDeviceId = createSelector(
  getSabhaState,
  (state: SabhaState) => state.errorView.deviceId
);

export const getErrorViewPermission = createSelector(
  getSabhaState,
  (state: SabhaState) => state.errorView.permission
);

export const getErrorViewTechnicianName = createSelector(
  getSabhaState,
  (state: SabhaState) => state.errorView.technicianName
);

export const getErrorViewType = createSelector(
  getSabhaState,
  (state: SabhaState) => state.errorView.errorType
);

export const getErrorViewVideoCallStatus = createSelector(
  getSabhaState,
  (state: SabhaState) => state.errorView.isVideoCall
);

export const getErrorViewRoomId = createSelector(
  getSabhaState,
  (state: SabhaState) => state.errorView.roomId
);

export const getIsLicenseExpired = createSelector(
  getSabhaState,
  (state: SabhaState) => state.errorView.errorType === ErrorViewType.LicenseExpiredError
);

export const getPendingSelectRoom = createSelector(
  getSabhaState,
  (state: SabhaState) => state.deviceChatDialog.pendingActiveRoom
);


export const getRcDevice = createSelector(
  getSabhaState,
  (state: SabhaState) => state.rcDevice
);

export const getMinifiedDeviceView = createSelector(
  getSabhaState,
  (state: SabhaState) => state.minifiedViewDevice
);

export const getNotificationRoomIds = createSelector(
  getSabhaState,
  (state: SabhaState) => {
    return state.notificationRooms;
  }
);

export const getLocalPresenceStatus = createSelector(
  getSabhaState,
  (state: SabhaState) => state.localPresenceStatus
);

export const getAllPresenceStatuses = createSelector(
  getSabhaState,
  (state: SabhaState) => state.allPresenceStatuses
);

export const getSabhaInitState = createSelector(
  getSabhaState,
  (state: SabhaState) => state.sabhaInitState
);

export const getDeviceChatDialogState = createSelector(
  getSabhaState,
  (state: SabhaState) => state.deviceChatDialog
);

export const getActiveRoomId = createSelector(
  getDeviceChatDialogState,
  (state: DeviceChatDialogState) => {
    return state.roomId;
  }
);

export const getChatToggle = createSelector(
  getDeviceChatDialogState,
  (state: DeviceChatDialogState) => {
    return state.chatToggle;
  }
);

export const getActiveCallRoomId = createSelector(
  getSabhaState,
  (state: SabhaState) => state.callRoomId
);

export const getDeviceChatDialogSize = createSelector(
  getDeviceChatDialogState,
  (state: DeviceChatDialogState) => state.dialogSize
);

export const getDeviceChatDialogPosition = createSelector(
  getDeviceChatDialogState,
  (state: DeviceChatDialogState) => state.dialogPosition
);

export const getChatConfiguration = createSelector(
  getSabhaState,
  (state: SabhaState) => state.chatConfiguration
);

export const getAllowedMode = createSelector(
  getChatConfiguration,
  (state: IChatConfiguration) => state.supportChannel
);

export const getAudioAllowed = createSelector(
  getAllowedMode,
  (state: ChatSupportChannel) =>
    state === ChatSupportChannel.Voice || state === ChatSupportChannel.Video
);

export const getCallAllowed = createSelector(
  getAllowedMode,
  (state: ChatSupportChannel) =>
    state === ChatSupportChannel.Voice || state === ChatSupportChannel.Video
);

export const getVideoAllowed = createSelector(
  getAllowedMode,
  (state: ChatSupportChannel) => state === ChatSupportChannel.Video
);

export const getDeviceSearchText = createSelector(
  getSabhaState,
  (state: SabhaState) => state.deviceSearchText
);

export const isStartRoomLoading = createSelector(
  getSabhaState,
  (state: SabhaState) => state.isStartDeviceChatLoading
);

export const getMcConnections = createSelector(
  getSabhaState,
  (state: SabhaState) => state.mcConnections
);

export const getChatDialogSizeOnHide = createSelector(
  getDeviceChatDialogState,
  (state: DeviceChatDialogState) => state.dialogSizeOnHide
);

export const getDialogIds = createSelector(
  getSabhaState,
  (state: SabhaState) => state.dialogRefIds
);
